/* unplugin-vue-components disabled */import script from "./index.vue?vue&type=script&setup=true&lang=ts"
export * from "./index.vue?vue&type=script&setup=true&lang=ts"

import "./index.vue?vue&type=style&index=0&id=8e46fe52&lang=scss&scoped=true"

import exportComponent from "/Users/zhangmengxuan/Desktop/xinyan-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8e46fe52"]])

export default __exports__